import { jsx } from 'react/jsx-runtime';
import { isOneOf } from '@flysas-tech/adg-toolbox';
import clsx from 'clsx';
import { cloneElement } from 'react';
import invariant from '../utils/invariant.js';
import { TOKENS, icon, iconButton } from './icon.css.js';

const AS = Object.values(TOKENS.as);
const COLOR = Object.values(TOKENS.color);
const SIZE = Object.values(TOKENS.size);
const ROTATION = Object.values(TOKENS.rotation);
const validCombinations = [
  { size: TOKENS.size.sm, as: TOKENS.as.button },
  { size: TOKENS.size.md, as: TOKENS.as.button },
  { size: TOKENS.size.lg, as: TOKENS.as.button }
];
const isValidCombination = (size, as) => {
  return validCombinations.some((combination) => combination.size === size && combination.as === as);
};
function Icon({
  as: As = TOKENS.as.svg,
  children,
  className: classes,
  color = TOKENS.color.secondary,
  onDark = false,
  rotation = TOKENS.rotation["0"],
  size = TOKENS.size.md,
  variant = TOKENS.variant.primary,
  ...rest
}) {
  if (As === TOKENS.as.button && !isValidCombination(size, As)) {
    throw new Error(
      `Invalid combination of size: ${size} and as: ${As}. When rendering an icon as a button, the size must be one of 'sm', 'md', or 'lg'.`
    );
  }
  invariant(isOneOf(AS, As), `The 'as' prop must be one of '${AS}', but you passed '${As}'`);
  invariant(isOneOf(COLOR, color), `The 'color' prop must be one of ${COLOR}, but you passed '${color}'`);
  invariant(isOneOf(SIZE, size), `The 'size' prop must be one of ${SIZE}, but you passed '${size}'`);
  invariant(
    isOneOf(ROTATION, rotation),
    `The 'rotation' prop must be one of ${ROTATION}, but you passed '${rotation}'`
  );
  const className = clsx(icon({ size, color, rotation, as: As }), classes);
  const buttonClassName = clsx(iconButton({ size, onDark, variant }));
  if (As === TOKENS.as.button) {
    return /* @__PURE__ */ jsx("button", { className: buttonClassName, "data-on-dark": onDark, ...rest, children: cloneElement(children, { className, ...rest }) });
  }
  return cloneElement(children, { className, ...rest });
}

export { Icon, Icon as default, TOKENS as tokens };
